import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StepStatus } from '../../utils/hooks/usePipeline';
import Loader from '../Loader/loader';
import {
    StepRowStyled,
    StepMainRowStyled,
    StepIconCircleStyled,
    StepLabelTextStyled,
    StepErrorPanelStyled,
    StepErrorTextStyled,
    RetryButtonStyled,
} from './styled';

interface PipelineStepProps {
    label: string;
    status: StepStatus;
    error?: string;
    onRetry: () => void;
}

const StepIcon: FC<{ status: StepStatus }> = ({ status }) => {
    if (status === 'running') { return <Loader size={20} />; }
    if (status === 'success') { return <StepIconCircleStyled status="success">✓</StepIconCircleStyled>; }
    if (status === 'error') { return <StepIconCircleStyled status="error">✕</StepIconCircleStyled>; }

    return <StepIconCircleStyled status="idle" />;
};

const PipelineStep: FC<PipelineStepProps> = ({
    label, status, error, onRetry,
}) => {
    const { t } = useTranslation('settings');

    return (
        <StepRowStyled>
            <StepMainRowStyled>
                <StepIcon status={status} />
                <StepLabelTextStyled status={status}>{label}</StepLabelTextStyled>
            </StepMainRowStyled>

            {status === 'error' && error && (
                <StepErrorPanelStyled>
                    <StepErrorTextStyled>{error}</StepErrorTextStyled>
                    <RetryButtonStyled onClick={onRetry}>
                        {t('tabs.createSurvey.step6Content.retry')}
                    </RetryButtonStyled>
                </StepErrorPanelStyled>
            )}
        </StepRowStyled>
    );
};

export default PipelineStep;
